export default "__VITE_ASSET__VjNOwezn__"